import { render, staticRenderFns } from "./add-edit-api-setting.vue?vue&type=template&id=4d09bbcb&"
import script from "./add-edit-api-setting.vue?vue&type=script&lang=js&"
export * from "./add-edit-api-setting.vue?vue&type=script&lang=js&"
import style0 from "./add-edit-api-setting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports